import { render, staticRenderFns } from "./BusinessMerchantProcessing.vue?vue&type=template&id=15e5ee42&scoped=true"
import script from "./BusinessMerchantProcessing.vue?vue&type=script&lang=js"
export * from "./BusinessMerchantProcessing.vue?vue&type=script&lang=js"
import style0 from "./BusinessMerchantProcessing.vue?vue&type=style&index=0&id=15e5ee42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e5ee42",
  null
  
)

export default component.exports